const ROUTES = { AuthCallback: "/auth/callback", Home: "/" } as const;

type Route = keyof typeof ROUTES;

export const router = {
  getPattern: (route: Route): string => ROUTES[route],
  getUrl: (route: Route): string => ROUTES[route],
} as const;
